export default "__VITE_ASSET__pwFaYPDk__"